export const getApartmentsSizeDropdownEntries = (apartmentCategories) => {
    if (!apartmentCategories) {
        return false;
    }

    const sizes = [...new Set(apartmentCategories.map(apartmentCategory => apartmentCategory.fields.no_of_rooms))];

    return sizes.map(number => ({
        key: number.toString(),
        value: number,
        label: number.toString() + (number === 1 ? " Room" : " Rooms")
    }));

};

export const getWheelchairAccessibilityFromApartments = (apartments) => {
    return apartments?.some(apartment => apartment.wheelchair_accessibility);
};
